import React from "react";
import "../style.scss";
const CreationSummary = ({ propertyType, aditionalForMember, image, count, totalCount }) => {
   return (
      <div>
         <div className="d-flex align-items-center justify-content-between creationSummaryContainer">
            <div>
               <span className="countNumber">{count}</span>
               <label className="labelForProperty">
                  {propertyType}
                  <span className="additionalText">{aditionalForMember}</span>
               </label>
            </div>
            <img src={image} alt="clipboard-icon" width={"64px"} />
         </div>
      </div>
   );
};

export default CreationSummary;
